import React from "react";
import { Box, Typography, Button } from "@mui/material";

const PageNotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        flexDirection: "column",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{ fontSize: "10rem", fontWeight: "bold", color: "#3f51b5" }}
      >
        404
      </Typography>
      <Typography
        variant="h6"
        sx={{ mb: 3, fontSize: "1.5rem", color: "#616161" }}
      >
        Oops! The page you are looking for doesn't exist.
      </Typography>
    </Box>
  );
};

export default PageNotFound;
